import React from 'react'
import './footer.css'

function Footer() {
  return (
    <div className='footer'     >
        
        <p className='f' >&copy; Mahdi. All rights reserved.</p>
    </div>
  )
}

export default Footer